"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserPreferences = exports.getUserPreferences = exports.GET_PREFERENCES = void 0;

var _avlComponents = require("@availabs/avl-components");

var _utils = require("./utils");

var GET_PREFERENCES = "AMS::GET_PREFERENCES";
exports.GET_PREFERENCES = GET_PREFERENCES;

var getUserPreferences = function getUserPreferences() {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      var _Config = (0, _utils.Config)(),
          AUTH_HOST = _Config.AUTH_HOST,
          PROJECT_NAME = _Config.PROJECT_NAME;

      (0, _utils.postJson)("".concat(AUTH_HOST, "/preferences"), {
        token: token,
        project: PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch({
            type: GET_PREFERENCES,
            preferences: res.preferences || {}
          });
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.getUserPreferences = getUserPreferences;

var updateUserPreferences = function updateUserPreferences(preferences) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      var _Config2 = (0, _utils.Config)(),
          AUTH_HOST = _Config2.AUTH_HOST,
          PROJECT_NAME = _Config2.PROJECT_NAME;

      (0, _utils.postJson)("".concat(AUTH_HOST, "/preferences/update"), {
        token: token,
        project: PROJECT_NAME,
        preferences: preferences
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          dispatch({
            type: GET_PREFERENCES,
            preferences: res.preferences
          });
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.updateUserPreferences = updateUserPreferences;